import { render, staticRenderFns } from "./CancelSubmitForm22.vue?vue&type=template&id=5c21bc20&scoped=true"
import script from "./CancelSubmitForm22.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm22.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21bc20",
  null
  
)

export default component.exports